// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui components
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

// material ui icons
import { makeStyles } from "@material-ui/core/styles";
import Check from "@material-ui/icons/Check";

// core components
import Button from "beaktShared/components/CustomButtons/Button.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";

// services
import { getAvaliacaoCookie, setAvaliacaoCookie } from 'beaktClinic/services/avaliacaoCookie';
import { SessionContext } from "beaktShared/services/session";

// style
import { MaskDecimal, MaskInt, transformValueFormatedtoFloat } from "beaktShared/helpers/masks";
import styles from "assets/jss/BeaktClinic/views/Avaliacao/dadosMedidas.js";
import styles2 from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function DadosMedidas({ nextButtonClick, previousButtonClick, classes_wizard, avaliacaoFranquia }) {
  const { t } = useTranslation();
  const session = useContext(SessionContext);
  const classes = useStyles();
  const classes2 = useStyles2();
  const { register, handleSubmit, errors, setValue, clearError} = useForm({mode: "onBlur"});
    
  const [sedentarismo, setSedentarismo] = React.useState("");

  useEffect(() => {
    loadingDados();
  }, []);

  const[realizaAcompanhamentoDiabetesCheckbox, setRealizaAcompanhamentoDiabetesCheckbox] = React.useState(false);

  const loadingDados = () => {
    let avaliacao = getAvaliacaoCookie();

    console.log('session: ' + session.franquiaId);

    if (avaliacao === null || avaliacao.avaliacao === 0)
      return;
    
    setValue('kg', avaliacao.kg);
    setValue('altura', avaliacao.altura);
    setValue('idade', avaliacao.idade);
    setValue('quadril', avaliacao.quadril);
    setValue('cintura', avaliacao.cintura);
    setValue('peso5anos', avaliacao.peso5anos);
    setValue('gordura', avaliacao.gordura);
    setValue('sedentarismo', avaliacao.sedentarismo);  
    setValue('diametroPunho', avaliacao.diametroPunho);
    setValue('diametroJoelho', avaliacao.diametroJoelho);
    setValue('realizaAcompanhamentoDiabete', avaliacao.realizaAcompanhamentoDiabete);
    setRealizaAcompanhamentoDiabetesCheckbox(avaliacao.realizaAcompanhamentoDiabete);
  }

  const reinicializarClick = () => {
    setAvaliacaoCookie(null);    
    previousButtonClick();
  }

  const handleSedentarismoChange = event => {
    setSedentarismo(event.target.value);
    setValue("sedentarismo", event.target.value);
    if (event.target.value !== "")
      clearError("sedentarismo");
  }

  const onSubmit = (dados) => {
    let avaliacao = getAvaliacaoCookie();
    avaliacao.kg = transformValueFormatedtoFloat(dados.kg);
    avaliacao.altura = dados.altura;
    avaliacao.idade = dados.idade;
    avaliacao.quadril  = transformValueFormatedtoFloat(dados.quadril);
    avaliacao.cintura = transformValueFormatedtoFloat(dados.cintura);
    avaliacao.peso5anos = transformValueFormatedtoFloat(dados.peso5anos);
    avaliacao.gordura = transformValueFormatedtoFloat(dados.gordura);
    avaliacao.sedentarismo = dados.sedentarismo; 
    avaliacao.diametroPunho = transformValueFormatedtoFloat(dados.diametroPunho);
    avaliacao.diametroJoelho = transformValueFormatedtoFloat(dados.diametroJoelho);
    avaliacao.realizaAcompanhamentoDiabete = realizaAcompanhamentoDiabetesCheckbox;
    setAvaliacaoCookie(avaliacao);
    nextButtonClick();
  }
  
  return (
    <div>   
        <form onSubmit={handleSubmit(onSubmit)}>
          <div style={{maxWidth:'800px',margin:'0 auto'}}>
            <GridContainer>
              <GridItem xs={12} sm={5} md={5}>
                <div className={classes.labelIdent}>
                  {t('label.weight')}<br/>
                  <small>({t('avaliation.type_in_lbs')})</small>
                </div>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}>
                  <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{shrink: true}} 
                      defaultValue=""  
                      name="kg"                       
                      error={errors.kg?true:false} 
                      inputRef={register({required: true})}                      
                      InputProps={{inputComponent: MaskDecimal}}     
                  />
                  <FormHelperText>
                      {errors.kg && <span className="obg">{t('label.required')}</span>}
                  </FormHelperText>   
              </GridItem>
              </GridContainer>

              <GridContainer>
              <GridItem xs={12} sm={5} md={5}>
                <div className={classes.labelIdent}>
                  {t('label.height')}<br/>
                  <small>({t('avaliation.type_in_in')})</small>
                </div>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}>
                  <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{shrink: true}} 
                      defaultValue=""  
                      name="altura"                  
                      inputRef={register({required: true})}
                      error={errors.altura?true:false}
                      InputProps={{
                        inputComponent: MaskDecimal                        
                      }}     
                  />
                  <FormHelperText>
                      {errors.altura && <span className="obg">{t('label.required')}</span>}
                  </FormHelperText>   
              </GridItem>
              </GridContainer>
              <GridContainer>
              <GridItem xs={12} sm={5} md={5}>
                <div className={classes.labelIdent}>
                  {t('label.age')}<br/>
                  <small>({t('avaliation.type_in_years')})</small>
                </div>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}>
                  <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{shrink: true}} 
                      defaultValue=""  
                      name="idade"                  
                      inputRef={register({required: true})}
                      error={errors.idade?true:false} 
                      InputProps={{
                        inputComponent: MaskInt                        
                      }}     
                  />
                  <FormHelperText>
                      {errors.idade && <span className="obg">{t('label.required')}</span>}
                  </FormHelperText>   
              </GridItem>
              </GridContainer>
              {
                session.franquiaId === 2 && session.clienteSexo === 1 ? (
                <>
                </>
                ) : 
                ( 
                  <>
                    <GridContainer>
                      <GridItem xs={12} sm={5} md={5}>
                        <div className={classes.labelIdent}>
                          {t('label.hip')}<br/>
                          <small>({t('avaliation.type_in_in')})</small>
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={3} md={3}>
                          <TextField
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}} 
                              defaultValue=""  
                              name="quadril"                  
                              inputRef={register({required: true})}
                              error={errors.quadril?true:false} 
                              InputProps={{
                                inputComponent: MaskDecimal                        
                              }}     
                          />
                          <FormHelperText>
                              {errors.quadril && <span className="obg">{t('label.required')}</span>}
                          </FormHelperText>   
                      </GridItem>
                    </GridContainer>
                  </>
                )
              }
              <GridContainer>
              <GridItem xs={12} sm={5} md={5}>
                <div className={classes.labelIdent}>
                  {t('label.waist')}<br/>
                  <small>({t('avaliation.type_in_in')})</small>
                </div>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}>
                  <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{shrink: true}} 
                      defaultValue=""  
                      name="cintura"                  
                      inputRef={register({required: true})}
                      error={errors.cintura?true:false} 
                      InputProps={{
                        inputComponent: MaskDecimal                        
                      }}     
                  />
                  <FormHelperText>
                      {errors.cintura && <span className="obg">{t('label.required')}</span>}
                  </FormHelperText>   
              </GridItem>
              </GridContainer>
              <GridContainer>
              <GridItem xs={12} sm={5} md={5}>
                <div className={classes.labelIdent}>
                  {t('label.weight_5_years_ago')}<br/>
                  <small>({t('avaliation.type_in_lbs')})</small>
                </div>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}>
                  <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{shrink: true}} 
                      defaultValue=""  
                      name="peso5anos"                  
                      inputRef={register({required: true})}
                      error={errors.peso5anos?true:false} 
                      InputProps={{
                        inputComponent: MaskDecimal                        
                      }}     
                  />
                  <FormHelperText>
                      {errors.peso5anos && <span className="obg">{t('label.required')}</span>}
                  </FormHelperText>   
              </GridItem>
              </GridContainer>

              <GridContainer>
              <GridItem xs={12} sm={5} md={5}>
                <div className={classes.labelIdent}>
                  {t('label.percent_fat')}<br/>
                  <small>({t('avaliation.type_in_percent')})</small>
                </div>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}>
                  <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{shrink: true}} 
                      defaultValue=""  
                      name="gordura"                  
                      inputRef={register({required: true})}
                      error={errors.gordura?true:false} 
                      InputProps={{
                        inputComponent: MaskDecimal                        
                      }}     
                  />
                  <FormHelperText>
                      {errors.gordura && <span className="obg">{t('label.required')}</span>}
                  </FormHelperText>   
              </GridItem>
              </GridContainer>

              <GridContainer>
              <GridItem xs={12} sm={5} md={5}>
                <div className={classes.labelIdent}>
                  {t('avaliation.sedentary_level')}<br/>
                  <small>({t('label.select')})</small>
                </div>
              </GridItem>
              <GridItem xs={12} sm={3} md={3}> 
                  <TextField
                    error={errors.sedentarismo ? true : false}                    
                    select
                    fullWidth
                    variant="outlined"              
                    value={sedentarismo}
                    onChange={handleSedentarismoChange}
                    name="sedentarismo"
                    ref={() => register({ name: "sedentarismo" },{ required: true  })}
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem value="0">0</MenuItem>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                    <MenuItem value="6">6</MenuItem>
                    <MenuItem value="7">7</MenuItem>
                    <MenuItem value="8">8</MenuItem>
                    <MenuItem value="9">9</MenuItem>
                    <MenuItem value="10">10</MenuItem>
                  </TextField>                                              
                <FormHelperText>
                    {errors.sedentarismo && <span className="obg">{t('label.required')}</span>}
                </FormHelperText>   
              </GridItem>
            </GridContainer>
            {/* {
              avaliacaoFranquia == "Dr. Diabetes" && 
              <GridContainer>
                <GridItem xs={12} sm={5} md={5}>
                  <div className={classes.labelIdent}>
                    {t('label.handle_diameter')}<br/>
                    <small>({t('avaliation.type_in_in')})</small>
                  </div>
                </GridItem>
                <GridItem xs={12} sm={3} md={3}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{shrink: true}} 
                        defaultValue=""  
                        name="diametroPunho"                  
                        inputRef={register({required: true})}
                        error={errors.diametroPunho?true:false} 
                        InputProps={{
                          inputComponent: MaskDecimal                        
                        }}     
                    />
                    <FormHelperText>
                        {errors.diametroPunho && <span className="obg">{t('label.required')}</span>}
                    </FormHelperText>   
                </GridItem>
              </GridContainer>
              } */}
              {/* {
                avaliacaoFranquia == "Dr. Diabetes" && 
                <GridContainer>
                  <GridItem xs={12} sm={5} md={5}>
                    <div className={classes.labelIdent}>
                      {t('label.knee_diameter')}<br/>
                      <small>({t('avaliation.type_in_in')})</small>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={3} md={3}>
                      <TextField
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{shrink: true}} 
                          defaultValue=""  
                          name="diametroJoelho"                  
                          inputRef={register({required: true})}
                          error={errors.diametroJoelho?true:false} 
                          InputProps={{
                            inputComponent: MaskDecimal                        
                          }}     
                      />
                      <FormHelperText>
                          {errors.diametroJoelho && <span className="obg">{t('label.required')}</span>}
                      </FormHelperText>   
                  </GridItem>
                </GridContainer>
              } */}
              {
                avaliacaoFranquia == "Dr. Diabetes" && 
                <GridContainer style={{ textAlign: 'center' }}>
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControlLabel
                      control = {
                        <Checkbox
                          tabIndex={-1}
                          checked={realizaAcompanhamentoDiabetesCheckbox}  
                          onClick={event => {setRealizaAcompanhamentoDiabetesCheckbox(event.target.checked)}}
                          name="realizaAcompanhamentoDiabetes"
                          checkedIcon={<Check className={classes2.checkedIcon} />}
                          icon={<Check className={classes2.uncheckedIcon} />}    
                          classes={{ checked: classes2.checked, root: classes2.checkRoot }}   
                          inputRef={register}
                        />
                      }
                      classes={{ label: classes2.label, root: classes2.labelRoot}}
                      label={t('avaliation.perform_diabetes_monitoring')+"?"}
                    />
                  </GridItem>
                </GridContainer>
              }
          </div>
          <div className={classes_wizard.right}>
          <Button type="submit"  className="no-print" color="primary">
              {t('button.next')}
          </Button>
        </div>
        <div className={classes_wizard.left}>
          <Button className="no-print" onClick={() => previousButtonClick()}>
            {t('button.previous')}
          </Button>
        </div>
        <div className={classes_wizard.left}>
          <Button className="no-print" color="warning" onClick={() => reinicializarClick()}>
            {t('button.restart')}
          </Button>
        </div>
        <br/>
        <br/>
      </form>
    </div>
);
}